import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { displayIcon } from "variables/icons";
import { NumberFormatter } from "utils/index";
import { getMyRewardSummary } from "../../redux/employeereward/employeeRewardState";

const PointsBalance = ({ }) => {
    const dispatch = useDispatch();
    const myRewardSummary = useSelector((state) => state.employeeReward.myRewardSummary);
    
    useEffect(() => {
        dispatch(getMyRewardSummary());
    }, [dispatch]);
    
    const recordList = myRewardSummary?.data || { balance: 0, percentile: 0, activities: [] };

    return (
        <span className="flex items-center justify-center rounded-lg text-xs font-medium gap-1.5 bg-gradient-to-r from-emerald-500 to-purple-500 text-white px-3 py-1">
          {displayIcon("Sparkles", 'w-3.5 h-3.5')} <span className="text-[11px] font-semibold">{NumberFormatter(recordList.balance ?? 0, 0)}</span>
        </span>

    );
};

export default PointsBalance;